import { matchPath } from 'react-router-dom';
import { AIToolkitOptions, ViewGptJobOptions } from '../domains/ai-toolkit';
import { queryString } from './heap';

const STARTING_PATH = '/';
const NOT_AUTHORISED_PATH = '/not-authorised';
const NOT_FOUND_PATH = '/not-found';

const HOME_PATH = '/home';
const ACCOUNT_SETUP_PATH = '/account-setup';
const NOT_APPROVED_PATH = '/new-account';
const REPORTS_DASHBOARD_V2_PATH = '/reports/dashboard';
const REPORTS_INSIGHTS_PATH = '/reports/insights';
const DATASTREAMS = '/datastreams';
const USERS = '/users';

const LINK_FORGE_PATH = '/tools/linkforge';
const CREATIVE_VOLUME_PLANNER_PATH = '/tools/creative-volume-checker';
const CREATIVE_GENERATION_PATH = '/tools/creative-generation';
const AI_TOOLKIT_PATH = '/tools/ai-toolkit';
const getAIToolkitPath = (tool: AIToolkitOptions): string =>
  `${AI_TOOLKIT_PATH}/${tool}`;
const CREATE_GPT_JOB_PATH = `${getAIToolkitPath(AIToolkitOptions.TITLE_OPTIMIZATION)}/create`;
const getViewGptJobPath = (jobId: string, view: ViewGptJobOptions): string => {
  return queryString.stringifyUrl({
    url: `${getAIToolkitPath(AIToolkitOptions.TITLE_OPTIMIZATION)}/${jobId}`,
    query: {
      view,
    },
  });
};

const SPECIALIST_MARKETPLACE_PATH = '/marketplace/specialist-marketplace';

const SPECIALIST_MARKETPLACE_SHARED_PATH =
  '/marketplace/specialist-marketplace/shared/:encodedEmail';

const FEEDBACK_PATH = '/feedback/:pageid';
const PREFERENCES_PATH = '/preferences';
const getPreferencesPath = (view: string): string => {
  return queryString.stringifyUrl({
    url: PREFERENCES_PATH,
    query: {
      view,
    },
  });
};

const PROFILE_PATH = '/profile';
const getProfilePath = (userId: string): string => {
  return `${PROFILE_PATH}/${userId}`;
};

const ADMIN_PATH = '/admin';
const getAdminPath = (view: string): string => {
  return queryString.stringifyUrl({
    url: ADMIN_PATH,
    query: {
      view,
    },
  });
};

const KNOWLEDGE_HUB_PATH = '/knowledge-hub';

const SHARED_PATH_PATTERNS = [SPECIALIST_MARKETPLACE_SHARED_PATH];

const isSharedPath = (currentPath: string): boolean => {
  return SHARED_PATH_PATTERNS.some(pattern => {
    const match = matchPath(
      {
        path: pattern,
        caseSensitive: false,
        end: true,
      },
      currentPath
    );

    return match !== null;
  });
};

export {
  HOME_PATH,
  STARTING_PATH,
  NOT_APPROVED_PATH,
  NOT_AUTHORISED_PATH,
  NOT_FOUND_PATH,
  CREATE_GPT_JOB_PATH,
  ACCOUNT_SETUP_PATH,
  AI_TOOLKIT_PATH,
  REPORTS_DASHBOARD_V2_PATH,
  REPORTS_INSIGHTS_PATH,
  PROFILE_PATH,
  PREFERENCES_PATH,
  ADMIN_PATH,
  DATASTREAMS,
  USERS,
  SPECIALIST_MARKETPLACE_PATH,
  SPECIALIST_MARKETPLACE_SHARED_PATH,
  KNOWLEDGE_HUB_PATH,
  getAIToolkitPath,
  getViewGptJobPath,
  getProfilePath,
  getPreferencesPath,
  getAdminPath,
  SHARED_PATH_PATTERNS,
  isSharedPath,
  FEEDBACK_PATH,
  LINK_FORGE_PATH,
  CREATIVE_GENERATION_PATH,
  CREATIVE_VOLUME_PLANNER_PATH,
};
